import { useEffect, useState } from "react";
import {
  collection,
  doc,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";
import { db } from "../config/firebase";
import { proData } from "../data/MainData";

const currentProjects = proData.map((project, index) => ({
  id: `local-${index}`,
  heading: project.heading,
  url: project.url,
  tag: project.tag,
  imageUrl: project.img,
  description: project.description || "",
  order: index,
  published: true,
}));

export default function usePortfolioProjects() {
  const [projects, setProjects] = useState(currentProjects);

  useEffect(() => {
    let initialized = false;
    let firestoreProjects = [];

    const updateVisibleProjects = () => {
      // Use Firestore projects only when explicitly initialized AND results exist.
      // Otherwise always fall back to local static data so the section is never blank.
      const useFirestore = initialized && firestoreProjects.length > 0;
      setProjects(useFirestore ? firestoreProjects : currentProjects);
    };

    const stopSettingsListener = onSnapshot(
      doc(db, "siteContent", "projects"),
      (snapshot) => {
        initialized = snapshot.exists() && snapshot.data().initialized === true;
        updateVisibleProjects();
      },
      (error) => {
        console.error("Could not load portfolio settings", error);
        initialized = false;
        updateVisibleProjects();
      },
    );

    // Fetch all documents ordered by `order` only — no composite index needed.
    // Filter published client-side to avoid requiring a Firestore composite index.
    const projectsQuery = query(
      collection(db, "portfolioProjects"),
      orderBy("order", "asc"),
    );

    const stopProjectsListener = onSnapshot(
      projectsQuery,
      (snapshot) => {
        firestoreProjects = snapshot.docs
          .map((projectDoc) => ({ id: projectDoc.id, ...projectDoc.data() }))
          .filter((p) => p.published === true);
        updateVisibleProjects();
      },
      (error) => {
        console.error("Could not load portfolio projects", error);
        initialized = false;
        updateVisibleProjects();
      },
    );

    return () => {
      stopSettingsListener();
      stopProjectsListener();
    };
  }, []);

  return projects;
}
